// Category quick-filter tiles. Progressive enhancement over plain filter links:
// clicking a tile updates the product grid in place via the theme's existing
// facet AJAX (FacetFiltersForm.renderPage). With JS off, the <a href> filter
// links still work with a normal page load.
(function () {
  const root = document.querySelector('.quick-filter');
  if (!root || typeof FacetFiltersForm === 'undefined') return;
  const KEY = root.dataset.filterKey;
  if (!KEY) return; // collection-nav mode: tiles are plain links, don't intercept

  function setActive(activeValues) {
    root.querySelectorAll('.quick-filter__item').forEach((li) => {
      const value = li.querySelector('.quick-filter__tile').dataset.value;
      li.classList.toggle('is-active', activeValues.includes(value));
    });
  }

  root.addEventListener('click', (event) => {
    const tile = event.target.closest('.quick-filter__tile');
    if (!tile) return;
    event.preventDefault();

    const params = new URLSearchParams(window.location.search);
    const wasActive = params.getAll(KEY).includes(tile.dataset.value);
    params.delete(KEY); // single-select: replace any current category
    params.delete('page');
    if (!wasActive) params.append(KEY, tile.dataset.value);

    setActive(wasActive ? [] : [tile.dataset.value]);
    FacetFiltersForm.renderPage(params.toString());
  });

  // Keep tiles in sync on browser back/forward (facets.js handles the grid).
  window.addEventListener('popstate', () => {
    setActive(new URLSearchParams(window.location.search).getAll(KEY));
  });
})();
